import { API_TYPE } from '@umu/umu-fetch';
const BasePath = '/uapi/v1/market';
const CommodityPath = '/uapi/v1/commodity';

export const MarketAPI = {
    /**
     * 课程推荐列表
     */
    MARKET_RECOMMEND_COURSE: {
        url: `${BasePath}/recommend-course-list`,
        type: API_TYPE.GET,
    },

    /**
     * 学习圈推荐列表
     */
    MARKET_RECOMMEND_CIRCLE: {
        url: `${BasePath}/recommend-circle-list`,
        type: API_TYPE.GET,
    },

    /**
     * 课程分类列表
     */
    MARKET_COURSE_LIST: {
        url: `${BasePath}/course-list`,
        type: API_TYPE.GET,
    },

    /**
     * 学习圈分类列表
     */
    MARKET_CIRCLE_LIST: {
        url: `${BasePath}/circle-list`,
        type: API_TYPE.GET,
    },

    /**
     * 企业洽谈
     */
    MARKET_NEGOTIATE: {
        url: `${BasePath}/business-negotiation`,
        type: API_TYPE.POST,
    },

    /**
     * 课程目录
     */
    MARKET_COURSE_CATALOG: {
        url: `${BasePath}/course-catalogue`,
        type: API_TYPE.GET,
    },

    /**
     * 课程目录
     */
    MARKET_CATEGORYS: {
        url: `${BasePath}/category-list`,
        type: API_TYPE.GET,
    },

    /**
     * 首页推荐位
     */
    MARKET_RECOMMEND: {
        url: `${BasePath}/index-cms-list`,
        type: API_TYPE.GET,
    },

    /**
     * 分类推荐
     */
    MARKET_CATEGORY_RECOMMENDS: {
        url: `${BasePath}//index-category-obj-list`,
        type: API_TYPE.GET,
    },

    /**
     * 根据课程或者小节id获取购买课程相关信息
     */
    MARKET_OUTER_OBJ_STATUS: {
        url: `${BasePath}/outer-obj-status`,
        type: API_TYPE.GET,
    },

    /**
     * 获取店铺内课程列表接口
     */
    MARKET_STORE_COURSE_LIST: {
        url: `${BasePath}/store/course-list`,
        type: API_TYPE.GET,
    },

    /**
     * 获取机构讲师列表
     */
    MARKET_STORE_LECTURER_LIST: {
        url: `${BasePath}/store/lecturer-list`,
        type: API_TYPE.GET,
    },


    /**
     * 免费课程列表
     */
    MARKET_FREE_COURSES: {
        url: `${CommodityPath}/free-course-list`,
        type: API_TYPE.GET,
    },

    /**
     * 领取课程并设置到首页
     */
    MARKET_IMPORT_COURSES: {
        url: `${CommodityPath}/import-course`,
        type: API_TYPE.POST,
    },
    /**
     * 是否已经领取免费课程
     */
    MARKET_FREE_COURSE_IS_IMPORTED: {
        url: `${CommodityPath}/free-course-is-imported`,
        type: API_TYPE.POST,
    },

};
